import fetch from '../utils/fetch-json';
import {
    FAILED_INVITATION,
    FETCHING_INVITATION,
    FETCHING_INVITATIONS,
    GOT_INVITATION,
    GOT_INVITATIONS,
} from './project-invitation-reducer';

export const fetchInvitationByURL =
    ({ fullUrl }) =>
    ({ dispatch, getState }) => {
        dispatch({ type: FETCHING_INVITATION });
        return fetch({ url: fullUrl, dispatch, getState })
            .then((response) => {
                dispatch({
                    type: GOT_INVITATION,
                    data: response.body,
                });
                return response.body;
            })
            .catch((e) => {
                dispatch({ type: FAILED_INVITATION, error: e.body });
                return Promise.reject(e);
            });
    };

export const fetchInvitationToProject =
    ({ projectId }) =>
    ({ dispatch, getState }) => {
        const fullUrl = getState().baseURL.concat(`/api/anonymous/project/${projectId}/invitation`);
        return dispatch(fetchInvitationByURL({ fullUrl }));
    };

export const fetchInvitationsToUser =
    () =>
    ({ dispatch, getState }) => {
        const fullUrl = getState().baseURL.concat(`/api/private/project/invitations/user`);
        dispatch({ type: FETCHING_INVITATIONS });
        return fetch({ url: fullUrl, dispatch, getState })
            .then((response) => {
                dispatch({
                    type: GOT_INVITATIONS,
                    data: response.body,
                });
                return response.body;
            })
            .catch((e) => {
                dispatch({ type: FAILED_INVITATION, error: e.body });
                return Promise.reject(e);
            });
    };

export const fetchInvitationById =
    ({ invitationId }) =>
    ({ dispatch, getState }) => {
        const fullUrl = getState().baseURL.concat(`/api/private/invitation/${invitationId}`);
        return dispatch(fetchInvitationByURL({ fullUrl }));
    };

export const acceptInvitation =
    () =>
    ({ dispatch, getState }) => {
        const fullUrl = getState().baseURL.concat(`/api/private/invitation/accept`);
        dispatch({ type: FETCHING_INVITATION });
        return fetch({ url: fullUrl, options: { method: 'PUT' }, dispatch, getState })
            .then((response) => {
                dispatch({
                    type: GOT_INVITATION,
                    data: response.body,
                });
                return response.body;
            })
            .catch((e) => {
                dispatch({ type: FAILED_INVITATION, error: e.body });
                return Promise.reject(e);
            });
    };
